var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.138,
    height: 20.071,
    viewBox: "0 0 24.138 20.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351",
    transform: "translate(-328.248 -687.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ios-paper",
    d: "M6.494,4.688V17.9a.574.574,0,1,1-1.149,0V6H4.688A1.311,1.311,0,0,0,3.375,7.314V19.133a1.311,1.311,0,0,0,1.313,1.313H19.178a1.269,1.269,0,0,0,1.268-1.268V4.688a1.311,1.311,0,0,0-1.313-1.313L7.725,3.457A1.176,1.176,0,0,0,6.494,4.688ZM9.2,6h3.447a.574.574,0,0,1,0,1.149H9.2A.574.574,0,0,1,9.2,6Zm0,6.566h6.073a.574.574,0,1,1,0,1.149H9.2a.574.574,0,1,1,0-1.149ZM17.245,17H9.2a.574.574,0,1,1,0-1.149h8.043a.574.574,0,1,1,0,1.149Zm0-6.566H9.2a.574.574,0,0,1,0-1.149h8.043a.574.574,0,1,1,0,1.149Z",
    transform: "translate(324.873 684.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(334.249 689.84)",
    fill: "#00c742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalNotes);
export default __webpack_public_path__ + "static/media/additional_notes.cc26a5c819b30faca3da00e39b3f04bf.svg";
export { ForwardRef as ReactComponent };